import { Box } from '@material-ui/core'
import React, { ReactNode } from 'react'

import { ReleaseCardTag, ReleaseCardTagProps } from './ReleaseCardTag'

const Annotation = ({
  children,
  height,
  ...tagProps
}: {
  children: ReactNode
  height?: string
} & ReleaseCardTagProps) => (
  <Box height={height}>
    <ReleaseCardTag {...tagProps} />
    {children}
  </Box>
)

export default Annotation
